export default "__VITE_ASSET__BKRjB6uD__"